import { useId, type MouseEventHandler } from 'react'
import { IconCheck } from '@tabler/icons-react'
import type { BreakUpPlan } from '../model/breakUpPricing'
import s from './BreakUpPricing.module.css'

interface Props {
  plan: BreakUpPlan
  payingId: string | null
  onPay: MouseEventHandler<HTMLButtonElement>
}

export default function BreakUpPlanCard({ plan, payingId, onPay }: Props) {
  const headingId = useId()
  const paying = payingId === plan.id
  return <article aria-labelledby={headingId} className={`${s.card} ${plan.featured ? s.featured : ''}`}>
    <div className={s.cardHeader}>
      <h2 id={headingId}>{plan.name}</h2>
      {plan.featured
        ? <span className={s.hit}>Хит</span>
        : <span className={`${s.renewal} ${plan.recurring ? '' : s.once}`}>{plan.recurring ? 'Автопродление' : 'Разовый платёж'}</span>}
    </div>
    {plan.featured && <p className={s.duration}>{plan.terms}</p>}
    <p className={s.price}>{plan.price}</p>
    <ul className={s.benefits}>
      {plan.benefits.map(benefit => <li key={benefit}><IconCheck size={16} aria-hidden="true" /><span>{benefit}</span></li>)}
    </ul>
    <div className={s.actions}>
      {plan.featured && plan.recurring && <p className={s.cancel}>Отмена в один шаг, в Настройках</p>}
      <button
        type="button"
        className={`${s.pay} ${plan.featured ? s.payFeatured : ''}`}
        value={plan.id}
        onClick={onPay}
        disabled={payingId !== null || plan.unavailable}
        aria-label={plan.unavailable ? 'Недоступно' : paying ? `Оплата тарифа «${plan.name}»` : `Оплатить тариф «${plan.name}»`}
      >{plan.unavailable ? 'Недоступно' : paying ? 'Оплата...' : 'Оплатить'}</button>
    </div>
  </article>
}
